import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";

class AccessDenied extends Component {

    render (){
        setTimeout(function() {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 100); 
        return (
            <div>
                <Breadcrumb title={'Access Denied'}/>

                <section className="p-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="error-section">
                                    <h1>403</h1>
                                    <h2>You do not have permission to view this page.</h2>
                                    <a href="/" className="btn btn-solid">back to home</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default AccessDenied